import React, { PureComponent } from 'react'
import Overlay from 'views/overlay/overlay'
import { connect } from 'react-redux'
import { localize } from 'helpers/translator'
import myLibraryActions from 'redux/actions/my_library_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

class OnboardingCreateLessonOverlay extends PureComponent {

	componentDidMount() {
		this.props.actions.overlayOnboardingCreateLessonInitialize()
	}

	componentWillUnmount() {
		this.props.actions.overlayOnboardingCreateLessonClose()
	}

		onButtonConfirm = () => {
			this.props.actions.overlayOnboardingCreateLessonConfirm()
		}

		onButtonDismiss = () => {
			this.props.actions.overlayOnboardingCreateLessonDismiss()
		}

		render() {
			const buttonOne = {text: localize('onboarding_overlay_lesson_create_action_button'), action: this.onButtonConfirm}
			const buttonDismiss = { text: localize('onboarding_overlay_lesson_create_action_dismiss'), action: this.onButtonDismiss}

			return <Overlay
				offerTitle={localize('onboarding_overlay_lesson_create_title')}
				offerMessage={localize('onboarding_overlay_lesson_create_body')}
				buttonOne={buttonOne}
				buttonDismiss={buttonDismiss}
				videoIcon={localize('onboarding_overlay_lesson_create_video_2')} />
		}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		overlayOnboardingCreateLessonInitialize: myLibraryActions.overlayOnboardingCreateLessonInitialize,
		overlayOnboardingCreateLessonConfirm: myLibraryActions.overlayOnboardingCreateLessonConfirm,
		overlayOnboardingCreateLessonDismiss: myLibraryActions.overlayOnboardingCreateLessonDismiss,
		overlayOnboardingCreateLessonClose: myLibraryActions.overlayOnboardingCreateLessonClose,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(OnboardingCreateLessonOverlay)


export { OnboardingCreateLessonOverlay }
